var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBestprice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7217 8.73917L2.55764 9.92809C2.26532 10.0887 1.90378 9.97125 1.7501 9.66578C1.6889 9.54414 1.66779 9.40481 1.69002 9.26936L2.10332 6.75117C2.13659 6.54847 2.07228 6.34163 1.93134 6.19807L0.180579 4.41468C-0.0559068 4.17379 -0.0607457 3.77817 0.169771 3.53104C0.261564 3.43263 0.381841 3.36859 0.51198 3.34883L2.93148 2.98143C3.12624 2.95185 3.29461 2.82402 3.38171 2.63959L4.46374 0.34847C4.6099 0.0389949 4.96846 -0.0880679 5.2646 0.0646671C5.38253 0.125487 5.47798 0.225235 5.53618 0.34847L6.61821 2.63959C6.70531 2.82402 6.87368 2.95185 7.06844 2.98143L9.48794 3.34883C9.81476 3.39845 10.0412 3.71554 9.99371 4.05707C9.9748 4.19307 9.91351 4.31876 9.81934 4.41468L8.06858 6.19807C7.92765 6.34163 7.86333 6.54847 7.8966 6.75117L8.3099 9.26936C8.36573 9.6095 8.14712 9.93254 7.82163 9.99088C7.69201 10.0141 7.55869 9.99204 7.44228 9.92809L5.27822 8.73917C5.10402 8.64346 4.8959 8.64346 4.7217 8.73917Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestprice);
export default __webpack_public_path__ + "static/media/bestprice.321a8271d0ab51e2d927b0926f4992d7.svg";
export { ForwardRef as ReactComponent };